import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTranslate } from "../../actions/settings";

import { CloseIcon, InfoIcon } from "../utils/svg";
import { useTranslation } from "react-i18next";
import { Button } from "@vshp/ui-components";
import i18next from "i18next";
import { setNoticeLocale } from "../../actions/global";

function HeaderNotice({ lang }) {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(true);

  const { t } = useTranslation();
  const { translate, translateLoading } = useSelector((state) => state.settings);

  const translationsKeys = "ui.locale_notice, ui.locale_notice_button";

  useEffect(() => {
    dispatch(fetchTranslate(translationsKeys, lang));
  }, [dispatch, lang]);

  i18next.addResourceBundle(lang, "translation", translate);

  const handleBtnClose = () => {
    setNoticeLocale();
    setOpen(false);
  };

  const changeLanguage = (lang) => () => {
    i18next.changeLanguage(lang);
    handleBtnClose();
  };

  return (
    <>
      {isOpen && !translateLoading && (
        <div className="notice">
          <div className="notice__inner">
            <div className="notice__info-icon">
              <InfoIcon />
            </div>
            <div className="notice__content">
              <div className="notice__title" data-key="ui.locale_notice">{t("ui.locale_notice", { ns: "translation", lng: lang })}</div>
            </div>
            <Button className="notice__close" size="small" icon={true} corners="square" onClick={handleBtnClose}>
              <CloseIcon />
            </Button>
            <Button className="notice__action notice__action_white" onClick={changeLanguage(lang)} data-key="ui.locale_notice_button">
              {t("ui.locale_notice_button", { ns: "translation", lng: lang })}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default HeaderNotice;
